import { v4 as uuidv4 } from 'uuid';
import { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useNavigate, generatePath } from 'react-router-dom';

// Our Components
import ColumnItem from 'components/DataTable/ColumnItem';
import ColumnVerticalHeader from 'components/DataTable/ColumnVerticalHeader';
import DeleteButton from 'components/DataTable/DeleteButton';
import InviteButton from 'components/DataTable/InviteButton';
import PaginationDataTable from 'components/DataTable/PaginationDataTable';

// Routes
import { ADVISOR_DYNAMIC_WALLET_ROUTE } from 'routes';

// Utilities
import { dollarFormatter } from 'shared/utils';

function FADashboardPaginationTable({
	liabilities,
	page,
	setPage,
	totalClient,
	isFetching
}) {
	const navigate = useNavigate();
	// currently in our liabilities table there isn't an id associated with the user so i'm created one here per row

	const liabilityData = useMemo(
		() =>
			liabilities.map((userLiabilityData) => ({
				...userLiabilityData,
				deleteKey: '',
				inviteKey: '',
				id: uuidv4()
			})),
		[liabilities]
	);

	const nameKey = 'name';
	const balanceKey = 'outstandingBalance';
	const numberOfLoansKey = 'numberOfLoans';
	const deleteKey = 'deleteKey';
	const inviteKey = 'inviteKey';
	const creditScoreKey = 'creditScore';

	const columnsLiability = [
		ColumnItem(nameKey, 'Name', 1.1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(numberOfLoansKey, 'Loans', 0.6, {
			valueFormatter: (params) => {
				const numberOfLoans = params.value;

				if (numberOfLoans || numberOfLoans === 0) return numberOfLoans;

				return 'NA';
			},
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),

		ColumnItem(balanceKey, 'Outstanding Balance', 1, {
			valueFormatter: (params) => {
				const outstandingBalance = params.value;
				if (!outstandingBalance && outstandingBalance !== 0)
					return 'NA';
				if (outstandingBalance === 0) return '$0';
				return dollarFormatter.format(outstandingBalance);
			},
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(creditScoreKey, 'Credit Score', 1, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			)
		}),
		ColumnItem(inviteKey, 'Login Link', 0.7, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			),
			renderCell: (params) => {
				const rowData = params.row;
				return <InviteButton rowData={rowData} />;
			}
		}),
		ColumnItem(deleteKey, 'Delete', 0.5, {
			renderHeader: ({ colDef }) => (
				<ColumnVerticalHeader headerName={colDef.headerName} />
			),
			renderCell: (params) => {
				const rowData = params.row;
				return <DeleteButton rowData={rowData} />;
			}
		})
	];

	return (
		<Grid item xs={12}>
			<PaginationDataTable
				pageSize={10}
				page={page}
				setCurrentPage={setPage}
				columns={columnsLiability}
				rows={liabilityData}
				rowCount={totalClient}
				withRowColorCheck
				isLoading={isFetching}
				disableSelectionOnClick
				handleRowClick={(row) => {
					if (isFetching) return;
					navigate(
						generatePath(ADVISOR_DYNAMIC_WALLET_ROUTE, {
							clientId: row.clientId
						})
					);
				}}
			/>
		</Grid>
	);
}

export default FADashboardPaginationTable;
